var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicrosoftLogoVystrdc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f3f3f3",
    d: "M0 0h23v23H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f35325",
    d: "M1 1h10v10H1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#81bc06",
    d: "M12 1h10v10H12z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#05a6f0",
    d: "M1 12h10v10H1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffba08",
    d: "M12 12h10v10H12z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftLogoVystrdc);
export default __webpack_public_path__ + "static/media/microsoft-logo-VYSTRDC.ffbc405740eee4b7d9652be40b36998d.svg";
export { ForwardRef as ReactComponent };